import React from 'react';

import './style.scoped.scss';
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';

const BackButton = ({ isAccount, backGoesHome, filter }) => {
  return isAccount && !backGoesHome ? (
    <div onClick={() => window.history.back()} className='back-button'>
      <FaArrowLeft />
      <p>Back</p>
    </div>
  ) : (
    <Link to={ROUTES.HOME} className='back-button'>
      <FaArrowLeft />
      <p>Back</p>
    </Link>
  );
};

export default BackButton;
